import { createSlice } from "@reduxjs/toolkit";
import { getShareYourThoughtsById, updateShareYourThoughtsById, deleteShareYourThoughts,createShareYourThoughts,getAllShareYourThoughts } from "../../API/FormsData/ShareYourThoughts";

const initialState = {
    getallshareYourThoughts: [],
    loading: false,
    error: null,
    totalPages: 0,
    currentPage: 1,
};

const shareYourThoughtsSlice = createSlice({
  name: "ShareYourThoughts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getShareYourThoughtsById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getShareYourThoughtsById.fulfilled, (state, action) => {
        state.loading = false;
        state.getallShareYourThoughts = [action.payload]; // Flat ShareYourThoughts object array
        state.error = null;
      })
      .addCase(getShareYourThoughtsById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateShareYourThoughtsById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateShareYourThoughtsById.fulfilled, (state, action) => {
        state.loading = false;
        state.updateShareYourThoughts = [action.payload]; // Flat ShareYourThoughts object array
        state.error = null;
      })
      .addCase(updateShareYourThoughtsById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteShareYourThoughts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteShareYourThoughts.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteshareYourThoughts = [action.payload]; // Flat shareYourThoughts object array
        state.error = null;
      })
      .addCase(deleteShareYourThoughts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAllShareYourThoughts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllShareYourThoughts.fulfilled, (state, action) => {
        state.loading = false;
        state.getallshareYourThoughts = action.payload.data;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.page;
      })
      .addCase(getAllShareYourThoughts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createShareYourThoughts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createShareYourThoughts.fulfilled, (state, action) => {
        state.loading = false;
        state.createShareYourThoughts = [action.payload]; // Flat ShareYourThoughts object array
        state.error = null;
      })
      .addCase(createShareYourThoughts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default shareYourThoughtsSlice.reducer;